var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Directive, Input } from '@angular/core';
var BusyIfDirective = /** @class */ (function () {
    function BusyIfDirective(_element) {
        this._element = _element;
    }
    Object.defineProperty(BusyIfDirective.prototype, "busyIf", {
        set: function (isBusy) {
            this.refreshState(isBusy);
        },
        enumerable: true,
        configurable: true
    });
    BusyIfDirective.prototype.refreshState = function (isBusy) {
        if (isBusy === undefined) {
            return;
        }
        if (isBusy) {
            abp.ui.setBusy($(this._element.nativeElement));
        }
        else {
            abp.ui.clearBusy($(this._element.nativeElement));
        }
    };
    __decorate([
        Input()
    ], BusyIfDirective.prototype, "busyIf", null);
    BusyIfDirective = __decorate([
        Directive({
            selector: '[busyIf]'
        })
    ], BusyIfDirective);
    return BusyIfDirective;
}());
export { BusyIfDirective };
